/* eslint-disable semi */
import { createDecorator } from 'vue-class-component';
import * as utils from './utils';
import DecoratorConfigs from './DecoratorConfigs';

const debug = process.env.NODE_ENV === 'development';

const DECORATOR_NAME = 'Asynchronous';

/**
 * その関数が非同期処理であることを明示する
 * @param  {...any} args
 */
export default function Asynchronous (...args) {
  if (utils.isDecoratorCall(args)) {
    createAppDecorator()(...args);
  } else {
    if (debug) {
      console.error(`${DECORATOR_NAME}: USAGE @${DECORATOR_NAME}`);
    }
    return createAppDecorator(...args);
  }
}

function createAppDecorator (decoratorOptions = {}) {
  // 設定値のマージ
  decoratorOptions = DecoratorConfigs.marge(DECORATOR_NAME, decoratorOptions);

  // 実装時の整合性チェック
  if (debug) {
    utils.validateDecoratorOptions(DECORATOR_NAME, {}, decoratorOptions);
  }

  return createDecorator((options, key) => {
    // 実装時の整合性チェック
    if (debug) {
      console.debug(`${DECORATOR_NAME}: @ ${key}`);

      // 関数の戻り値がPromiseでない場合はエラー出力する
      const target = options.methods[key];
      options.methods[key] = utils.injectAfter(target, function (args, result) {
        try {
          result.then(() => { }).catch(() => { });
        } catch (e) {
          console.error(`${DECORATOR_NAME}: ${key}() is not asynchronous.`);
        }
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/core/decorators/Asynchronous.js